import { render, staticRenderFns } from "./GerenciaResultadoAvaliacaoPorHabilidade.vue?vue&type=template&id=3e4fefc8"
import script from "./GerenciaResultadoAvaliacaoPorHabilidade.vue?vue&type=script&lang=js"
export * from "./GerenciaResultadoAvaliacaoPorHabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports